/* eslint-disable camelcase */
import React, { useEffect, useState, useRef } from 'react';
import {
    withLoadingAsync,
    showToast,
    showModal
} from '../../services/common-service';
import {
    getBucket,
    getBucketVariable,
    storeBucketVariable,
    deleteBucketVariable
} from '../../services/bucket-service';
import { getConfigurationAsync } from '../../services/configuration-service';
import { getApplicationDataAsync } from '../../services/application-service';
import { getLoggedUserAsync } from '../../services/user-service';
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types';
import InputChips from '../../components/InputChips';
import Select from '../../components/Select';
import Modal from '../../components/Modal';
import Card from '../../components/Card';
import { v4 as uuidv4 } from 'uuid';
import sherlock from '../../assets/images/sherlock.png';
import axios from 'axios';
import settings from '../../config';

const Carteira = () => {
    const [appInfo, setAppInfo] = useState({});
    const [user, setUser] = useState({});
    const [configuration, setConfiguration] = useState({});
    const [phoneNumber, setPhoneNumber] = useState('');
    const [carteiraData, setCarteiraData] = useState([]);
    const [edited, setEdited] = useState(false);

    const fileInputRef = useRef(null);

    const HEADER_CONTENT = {
        'x-api-key': settings.api.key, // Adiciona a chave da API diretamente
        'Content-Type': 'application/json',
    };

    useEffect(() => {
        getAppDataAsync();
        //LoadCarteiraAsync();
        buscarCarteira();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // eslint-disable-next-line
    }, [carteiraData]);

    const handleUploadButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {


        const file = event.target.files[0];

        // Verificar se o arquivo é um CSV
        if (!file || file.type !== 'text/csv') {
            showToast({
                type: BlipPortalToastTypes.ERROR,
                message: "O arquivo deve ser um CSV."
            });
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        withLoadingAsync(async () => {
            try {
                const response = await axios.post(
                    settings.api.url,
                    formData,
                    {
                        headers: {
                            ...HEADER_CONTENT,
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                // Exibir mensagem de sucesso e atualizar o estado
                showToast({
                    type: BlipPortalToastTypes.SUCCESS,
                    message: "Análise deletada com sucesso"
                });

                buscarCarteira();
            } catch (error) {
                console.error('Erro ao enviar o arquivo:', error);
                showToast({
                    type: BlipPortalToastTypes.ERROR,
                    message: "Arquivo ainda está sendo carregado, aguarde 30 segundos e recarregue a página."
                });
                setTimeout(function() {
                    buscarCarteira();
                }, 25000);
            } finally {
                // Limpar o input de arquivo após o upload
                event.target.value = '';
            }
        })
    };

    const getAppDataAsync = async () => {
        const app = await getApplicationDataAsync();
        setAppInfo(app);

        const loggedUser = await getLoggedUserAsync();
        setUser(loggedUser);

        const configurationVariables = await getConfigurationAsync(
            app.shortName
        );
        setConfiguration(configurationVariables);

        const countryCode = configurationVariables['items'].find(
            (obj) =>
                obj['name'] === 'CountryCode' &&
                obj['owner'] === 'postmaster@wa.gw.msging.net'
        );
        const phoneNumber = configurationVariables['items'].find(
            (obj) =>
                obj['name'] === 'PhoneNumber' &&
                obj['owner'] === 'postmaster@wa.gw.msging.net'
        );
        setPhoneNumber(countryCode['value'] + phoneNumber['value']);
    };


    const updateCarteiraData = (index, newItem) => {
        setCarteiraData((carteiraData) => {
            const updatedList = [...carteiraData];
            updatedList[index] = newItem;
            return updatedList;
        });
        setEdited(true);
    };

    const deleteCarteiraData = (index) => {
        setCarteiraData((carteiraData) => {
            if (carteiraData.length > 1) {
                let updatedList = [...carteiraData];
                updatedList.splice(index, 1);
                return updatedList;
            } else {
                return [];
            }
        });
        setEdited(true);
    };

    const newCarteira = () => {
        setCarteiraData((carteiraData) => {
            const updatedList = [...carteiraData];
            updatedList.push({
                telefone: '',
                nome: '',
                unidade: '',
                regiao: '',
                acesso: ''
            });
            return updatedList;
        });
    };

    const handleDownload = () => {
        if (!carteiraData || carteiraData.length === 0) {
            console.error("Nenhum dado disponível para download.");
            return;
        }

        // Obter os headers a partir das chaves do primeiro objeto
        const headers = Object.keys(carteiraData[0]);

        // Construir o conteúdo do CSV
        /*const csvContent = [
            headers.join(';'), // Linha de cabeçalho
            ...carteiraData.map(row =>
                headers.map(header => `"${(row[header] || '').toString().replace(/"/g, '""')}"`).join(';')
            )
        ].join('\n');*/

        const csvContent = [
            headers.join(';'), // Linha de cabeçalho
            ...carteiraData.map(row =>
                headers.map(header => {
                    let cell = row[header] || '';
                    return `"${cell.replace(/"/g, '""')}"`;
                }).join(';')
            )
        ].join('\n');

        // Criar um blob com o conteúdo CSV
        const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = URL.createObjectURL(csvBlob);

        // Criar e simular o clique em um link de download
        const downloadLink = document.createElement('a');
        downloadLink.href = downloadUrl;
        downloadLink.download = `Contatos_${new Date().toISOString()}.csv`;
        downloadLink.click();
    };

    const carteiraAPIRequest = () => {
        const api = axios.create({
            baseURL: settings.api.url, // Utiliza a base URL do appsettings
        });

        api.interceptors.request.use(async (config) => {
            // Adiciona os headers do HEADER_CONTENT preservando os existentes
            return {
                ...config,
                headers: {
                    ...config.headers,
                    ...HEADER_CONTENT,
                },
            };
        });

        return api;
    };

    // Função para realizar a operação "buscar"
    const buscarCarteira = async () => {
        withLoadingAsync(async () => {
            const api = carteiraAPIRequest();
            try {
                const response = await api.post('', { format: 'title', operation: 'buscar' });
                console.log('Resposta da API:', response.data);
                //return response.data;
                setCarteiraData(response.data.data);
            } catch (error) {
                console.error('Erro na requisição:', error.response?.data || error.message);
                throw error;
            }
        })
    };
    return (
        <>
            <div className="ph1 ph4-m ph5-ns mt3">
                <div className="flex justify-end mb3">
                    <div className="mr3">
                        <bds-button-icon
                            variant="secondary"
                            size="short"
                            icon="upload"
                            onClick={handleUploadButtonClick}
                        />
                        <input
                            type="file"
                            accept=".csv"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className="mr3">
                        <bds-button-icon
                            variant="secondary"
                            size="short"
                            icon="download"
                            onClick={() => {
                                handleDownload();
                            }}
                        />
                    </div>
                    <div className="mr3">
                        <bds-button-icon
                            variant="secondary"
                            size="short"
                            icon="refresh"
                            onClick={() => {
                                buscarCarteira();
                            }}
                        />
                    </div>
                    <bds-button
                        variant="primary"
                        disabled={!edited}
                        onClick={() => {
                            withLoadingAsync(async () => {
                                console.log(carteiraData);
                                await storeBucketVariable(
                                    'Carteira-Data-Plugin',
                                    { carteira: carteiraData }
                                );
                                setEdited(false);
                            });
                        }}
                    >
                        Salvar
                    </bds-button>
                </div>
                <bds-table>
                    <bds-table-header>
                        <bds-table-row>
                            <bds-table-th key="Telefone">Telefone</bds-table-th>
                            <bds-table-th key="Nome">Nome</bds-table-th>
                            <bds-table-th key="Unidade">Unidade</bds-table-th>
                            <bds-table-th key="Regiao">Regiao</bds-table-th>
                            <bds-table-th key="Acesso">Acesso</bds-table-th>
                        </bds-table-row>
                    </bds-table-header>
                    <bds-table-body>
                        {carteiraData?.map((row, index) => {
                            return (
                                <bds-table-row key={index}>
                                    <bds-table-cell>
                                        {row.telefone}
                                    </bds-table-cell>
                                    <bds-table-cell>
                                        {row.nome}
                                    </bds-table-cell>
                                    <bds-table-cell>
                                        {row.unidade}
                                    </bds-table-cell>
                                    <bds-table-cell>
                                        {row.regiao}
                                    </bds-table-cell>
                                    <bds-table-cell>
                                        {row.acesso}
                                    </bds-table-cell>
                                </bds-table-row>
                            );
                        })}
                    </bds-table-body>
                </bds-table>

                {carteiraData.length === 0 && (
                    <div className="mt5">
                        <div className="flex justify-center">
                            <img
                                className="w-10"
                                src={sherlock}
                                alt="sherlock"
                            />
                        </div>
                        <div className="flex justify-center">
                            <h2 style={{ color: '#6E7B91' }}>
                                Você ainda não tem contatos cadastrados, envie sua planilha em formato csv
                            </h2>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};



export default Carteira;
